import Vue from 'vue';
import IconSvg from '@/components/svg-icon/IconSvg.vue';

Vue.component('IconSvg', IconSvg)